<process-monitoring-details-template
  class="flex flex-1 h-full"
  [loading]="loading"
  [monitoringDetailsCountersCardData]="monitoringDetailsCountersCardData"
  [feedback360StatusOptions]="feedback360StatusOptions"
  [selfAssessmentStatusOptions]="selfAssessmentStatusOptions"
  [evaluationStatusOptions]="evaluationStatusOptions"
  [deliveryStatusOptions]="deliveryStatusOptions"
  [companyOptions]="companyOptions"
  [officeOptions]="officeOptions"
  [departmentOptions]="departmentOptions"
  [BUOptions]="BUOptions"
  [evaluatorsOptions]="evaluatorsOptions"
  [usersData]="usersData"
  [usersDataCount]="usersDataCount"
  [loadingUsersDataCount]="loadingUsersDataCount"
  [userFilterData]="userFilterData"
  [loadingUsersData]="loadingUsersData"
  [loadingUserFilterData]="loadingUserFilterData"
  [processName]="processName"
  [isDrawerVisible]="advancedFiltersDrawerVisible"
  [selectedFeedback360Statuses]="selectedFeedback360Statuses"
  [selectedSelfAssessmentStatuses]="selectedSelfAssessmentStatuses"
  [selectedEvaluationStatuses]="selectedEvaluationStatuses"
  [selectedDeliveryStatuses]="selectedDeliveryStatuses"
  [selectedCompanies]="selectedCompanyOptions"
  [selectedEvaluators]="selectedEvaluatorOptions"
  [selectedDepartments]="selectedDepartmentOptions"
  [selectedOffices]="selectedOfficeOptions"
  [selectedBUs]="selectedBUOptions"
  [appliedFeedback360Statuses]="appliedFeedback360Statuses"
  [appliedSelfAssessmentStatuses]="appliedSelfAssessmentStatuses"
  [appliedEvaluationStatuses]="appliedEvaluationStatuses"
  [appliedDeliveryStatuses]="appliedDeliveryStatuses"
  [appliedCompanyOptions]="appliedCompanyOptions"
  [appliedEvaluatorsOptions]="appliedEvaluatorsOptions"
  [appliedDepartmentOptions]="appliedDepartmentOptions"
  [appliedOfficeOptions]="appliedOfficeOptions"
  [appliedBUOptions]="appliedBUOptions"
  (backClick)="goBack()"
  (onFeedback360StatusesChange)="onFeedback360StatusesChange($event)"
  (onSelfAssessmentStatusesChange)="onSelfAssessmentStatusesChange($event)"
  (onEvaluationStatusesChange)="onEvaluationStatusesChange($event)"
  (onDeliveryStatusesChange)="onDeliveryStatusesChange($event)"
  (onCompanyChange)="onCompanyChange($event)"
  (onEvaluatorChange)="onEvaluatorChange($event)"
  (onDepartmentChange)="onDepartmentChange($event)"
  (onOfficeChange)="onOfficeChange($event)"
  (onBUChange)="onBUChange($event)"
  (onRemoveFilterFromPage)="onRemoveFilterFromPage($event)"
  (onResetFilters)="resetFilters()"
  (onCloseDrawer)="closeDrawer()"
  (onApplyFilters)="applyFilters()"
  [allUsersChecked]="allUsersChecked"
  [page]="page"
  [pageSize]="pageSize"
  [totalPages]="totalPages"
  [searchedText]="searchedText"
  [allUsersData]="allUsersData"
  [processId]="processId"
  (onPageChange)="onPageChange($event)"
  (onPageSizeChange)="onPageSizeChange($event)"
  (onAdvancedFiltersClicked)="onAdvancedFiltersClicked()"
  (onSearchChange)="onSearchChange($event)"
  (onSearchUsers)="onSearchUsers()"
  (onSortChange)="onSortChange($event)"
  (onImpersonateUser)="onImpersonateUser($event)"
  (onImpersonateManager)="onImpersonateManager($event)"
  (onExportProcessReport)="onExportProcessReport($event)"
  [sortOptions]="sortOptions"
  [selectedSortOption]="selectedSortOption"
  (onReopenEvaluation)="onReopenEvaluation($event)"
  (onReopenSelfEvaluation)="onReopenSelfEvaluation($event)"
  [processPhases]="processPhases"
  [processStatus]="processStatus"
  (onSolicitEvaluation)="onSolicitEvaluation($event)"
  (onSolicitSelfEvaluation)="onSolicitSelfEvaluation($event)"
  (onSolicitMassiveEvaluation)="onSolicitMassiveEvaluation()"
  (onSolicitMassiveSelfEvaluation)="onSolicitMassiveSelfEvaluation()"
  (onDownloadEvaluationCard)="onDownloadEvaluationCard($event)"
  [showConfirmationModal]="showConfirmationModal"
  [confirmationSummary]="confirmationSummary"
  [isLoadingConfirmation]="isLoadingConfirmation"
  (onConfirmAndSend)="onConfirmAndSend()"
  (onConfirmModal)="onConfirmModal()"
  (onCancelModal)="onCancelModal()"
  (onCloseModal)="onCloseModal()"
  (onSendCalibrationCards)="onSendCalibrationCards($event)"
/>

<ape-toast />